import { useContext } from "react";
import { AnalyticsContext } from "../../../store/analyticsS";
import { HotelContext } from "../../../store/hotel";
import CustomDateRangePicker from "../../analytics/components/DateRangePicker";
import LoadingBookings from "../../common/LoadingBookings";
import ManagerUserAnalyticsGraph from "../../graph/managerUserAnalytics/ManagerAnalyticsGraph";

const ManagerUserAnalyticsScreen = () => {
  const analyticsContext = useContext(AnalyticsContext);
  const hotelContext = useContext(HotelContext);
  let managerUserAnalytics = analyticsContext.managerUserAnalytics;
  let allDates = Object.keys(managerUserAnalytics);

  const dateContent = (
    <div style={{ position: "absolute", top: "15px", left: "30px", zIndex: 4 }}>
      <CustomDateRangePicker
        startDay={hotelContext.startDay}
        days={hotelContext.days}
        onDateChange={(date, days) => {
          hotelContext.onUpdateDate(date, days);
        }}
      />
    </div>
  );

  if (
    analyticsContext.isManagerUserAnalyticsLoading ||
    !analyticsContext.isManagerUserAnalyticsLoaded
  ) {
    return (
      <>
        {dateContent}
        <LoadingBookings />
      </>
    );
  }

  return (
    <>
      {dateContent}
      {allDates.length > 0 && (
        <ManagerUserAnalyticsGraph
          managerUserAnalytics={managerUserAnalytics}
          title="Manager Analytics"
          isTablularData={analyticsContext.isTabularData}
          onToggleTabularData={() => {
            analyticsContext.onToggleTabularData();
          }}
          isBar={analyticsContext.isBar}
          isHotel={analyticsContext.isHotel}
          isDate={analyticsContext.isDate}
          isPercentage={analyticsContext.isPercentage}
          onTogglePercentage={() => {
            analyticsContext.onTogglePercentage();
          }}
          onToggleBar={() => {
            analyticsContext.onToggleBar();
          }}
          onToggleHotel={() => {
            analyticsContext.onToggleHotel();
          }}
          onToggleDate={() => {
            analyticsContext.onToggleDate();
          }}
        />
      )}
      {/* {!analyticsContext.isTabularData &&
        allDates.map((date) => {
          return (
            <SingleDateUserAnalyticsViewer
              key={date}
              date={date}
              dateData={bookingAnalytics[date]}
            />
          );
        })} */}
    </>
  );
};

export default ManagerUserAnalyticsScreen;
